import api from '@/lib/api'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// views
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Monks from '../views/Monks.vue'
import Calendar from '../views/telegram/Calendar.vue'
import Telegram from '../views/Telegram.vue'
import Users from '../views/telegram/Users.vue'
import ArticlesList from '../views/articoli/index.vue';
import ArticlesAdd from '../views/articoli/add.vue';
import NewCategory from '../views/categories/new.vue';
import AllCategories from '../views/categories/list.vue';
import NewResource from '../views/resources/new.vue';
import AllResources from '../views/resources/list.vue';

// components
import PanelView from '../components/PanelView.vue';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requires_login: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/monks',
    name: 'Monks',
    component: Monks,
    meta: { requires_login: true }
  },
  {
    path: '/resources',
    name: 'resources',
    component: PanelView,
    meta: { requires_login: true },
    children: [
      {
        path: 'create',
        name: 'crea risorsa',
        component: NewResource,
        meta: { requires_login: true }
      },
      {
        path: 'list',
        name: 'tutte le risorse',
        component: AllResources,
        meta: { requires_login: true }
      }
    ]
  },
  {
    path: '/categories',
    name: 'categories',
    component: PanelView,
    meta: { requires_login: true },
    children: [
      {
        path: 'create',
        name: 'Crea categoria',
        component: NewCategory,
        meta: { requires_login: true }
      },
      {
        path: 'list',
        name: 'Tutte le categorie',
        component: AllCategories,
        meta: { requires_login: true }
      }
    ]
  },
  {
    path: '/articoli',
    name: 'articoli',
    component: PanelView,
    meta: { requires_login: true },
    children: [
      {
        path: '',
        name: 'Articoli',
        component: ArticlesList,
        meta: { requires_login: true }
      },
      {
        path: 'add',
        name: 'Aggiungi articolo',
        component: ArticlesAdd,
        meta: { requires_login: true }
      }
    ]
  },
  {
    path: '/telegram',
    name: 'Telegram',
    component: PanelView,
    meta: { requires_login: true },
    children: [
      {
        path: '',
        name: 'Telegram',
        component: Telegram,
        meta: { requires_login: true }
      },
      {
        path: 'users',
        name: 'Utenti',
        component: Users,
        meta: { requires_login: true },
        children: [
          {
            path: ':page',
            name: 'Utenti',
            component: Users,
            meta: { requires_login: true }
          }
        ]
      },
      {
        name: 'Calendar',
        path: 'calendar',
        component: Calendar,
        meta: { requires_login: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(
  async(to, from, next) => {

    if(to.meta){

      if(to.meta.requires_login){

        try{
          
          const user = await api.auth.validate();
          console.log(user);
          next()

        }catch(err){

          location.href = "/login";

        }

      }

      next();

    }
  }
)

export default router
